import React, { FC } from "react";

export type TNegativeIconProps = React.SVGAttributes<SVGElement>;

const NegativeIcon: FC<TNegativeIconProps> = ({ ...rest }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...rest}>
      <rect width="32" height="32" rx="16" fill="#DCF3E0" />
      <path d="M22.364 20.95L20.9497 22.3642L9.63604 11.0505L11.0503 9.63627L22.364 20.95Z" fill="#21BE6B" />
      <path d="M11.0503 22.3642L9.63604 20.95L20.9497 9.63627L22.364 11.0505L11.0503 22.3642Z" fill="#21BE6B" />
    </svg>
  );
}

export default NegativeIcon;
